/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/handgame.glb')
  const { actions } = useAnimations(animations, group)

  const aiplay = props.useStore(state => state.aiplay)


  useEffect(()=>{

    // actions.scissor.repetitions = false
    actions.wave.play()
    
  },[])

  useEffect(()=>{

    switch(aiplay) {
      case '':
        actions.rock.stop()
        actions.paper.stop()
        actions.scissor.stop()

        actions.wave.play()

        break;
      case 'rock':
        actions.wave.stop()
        actions.paper.stop()
        actions.scissor.stop()

        actions.rock.play()
        actions.rock.repetitions = false
        break;
      case 'paper':
        actions.wave.stop()
        actions.scissor.stop()
        actions.rock.stop()

        actions.paper.play()
        actions.paper.repetitions = false
      break;
      case 'scissors':
          actions.wave.stop()
          actions.paper.stop()
          actions.rock.stop()

          actions.scissor.play()
          actions.scissor.repetitions = false
      break;
      default:
        // code block
    }
  }, [aiplay])


  return (
    <group ref={group} scale={[2.4,2.4,2.4]} position={[0,-3.7,0]} {...props} dispose={null}>
      <primitive object={nodes.Bone} />
      <skinnedMesh geometry={nodes.hand.geometry} material={materials.hand} skeleton={nodes.hand.skeleton} />
      <skinnedMesh geometry={nodes.sleeve.geometry} material={materials.sleeve} skeleton={nodes.sleeve.skeleton} />
    </group>
  )
}

useGLTF.preload('/handgame.glb')
